import { AppLayout } from "layouts";
import { lazy, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Loadable, Page } from "components";
import { setRouting } from "toolkits/redux/routing";
import { Navigate, useRoutes } from "react-router-dom";

const Dashboard = Loadable(
  lazy(() => import("screens/UnitAdminRole/Dashboard"))
);
const UserModel = Loadable(lazy(() => import("models/UserModel")));

const OrderView = Loadable(lazy(() => import("models/OrderModel/View")));
const OrderCreationNew = Loadable(
  lazy(() => import("screens/UnitAdminRole/OrderCreationNew"))
);
const OrderModel = Loadable(lazy(() => import("models/OrderModel")));
const Callback = Loadable(
  lazy(() => import("screens/Authentication/Callback"))
);
const LabModel = Loadable(lazy(() => import("models/LabModel")));
const PlanModel = Loadable(lazy(() => import("models/PlanModel")));

const navConfig = [
  {
    path: "/",
    element: <Navigate to="/app" replace />,
  },
  {
    url: "/",
    path: "/",
    title: "app",
    inSidebar: true,
    element: <AppLayout />,
    children: [
      {
        url: "/app",
        path: "/app",
        title: "app",
        inSidebar: true,
        element: <Dashboard />,
      },
      {
        url: "/callback",
        path: "/callback",
        title: "callback",
        inSidebar: false,
        element: <Callback />,
      },
      // {
      //   url: "/patient",
      //   path: "/patient",
      //   title: "PatientModel",
      //   inSidebar: true,
      //   element: (
      //     <Page>
      //       <UserModel initFilter={{ mode: "patient", type_ids: "1" }} />
      //     </Page>
      //   ),
      // },
      // {
      //   url: "/doctor",
      //   path: "/doctor",
      //   title: "DoctorModel",
      //   inSidebar: true,
      //   element: (
      //     <Page>
      //       <UserModel initFilter={{ mode: "doctor", type_ids: ["2", "3"] }} />
      //     </Page>
      //   ),
      // },
      {
        url: "/labs",
        path: "/labs",
        title: "LabModel",
        inSidebar: true,
        element: (
          <Page>
            <LabModel />
          </Page>
        ),
      },
      {
        url: "/order",
        path: "/order",
        title: "OrderModel",
        inSidebar: true,
        element: (
          <Page title="Orders">
            <OrderModel />
          </Page>
        ),
      },
      {
        url: "/order-creation-new",
        path: "/order-creation-new",
        title: "OrderCreation",
        inSidebar: true,
        element: <OrderCreationNew />,
      },
      {
        path: "/order/:id",
        title: "OrderView",
        inSidebar: false,
        element: (
          <Page title="OrderView">
            <OrderView />
          </Page>
        ),
      },
      // {
      //   url: "/plan",
      //   path: "/plan",
      //   title: "PlanModel",
      //   inSidebar: true,
      //   element: (
      //     <Page title="PlanModel">
      //       <PlanModel initFilter={{ related_to: "unit" }} />
      //     </Page>
      //   ),
      // },
    ],
  },
  {
    path: "/",
    element: <AppLayout />,
    children: [
      {
        path: "intro",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-in",
        element: <Navigate to="/" replace />,
      },
      {
        path: "sign-up",
        element: <Navigate to="/" replace />,
      },
      {
        path: "reset-password",
        element: <Navigate to="/" replace />,
      },
    ],
  },
  {
    path: "*",
    element: <Navigate to="/404" replace />,
  },
];

function cleanRoutes({ url, title, inSidebar, children }) {
  if (inSidebar) {
    if (children && children.length > 0) {
      children = children.map((c) => cleanRoutes(c));
      return { url, title, inSidebar, children };
    }
    return { url, title, inSidebar, children: [] };
  }
  return {};
}

export default function Router() {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setRouting(navConfig.map((x) => cleanRoutes(x)).filter((x) => x)));
  }, []);
  return useRoutes(navConfig);
}
